import React from 'react';
import { Link } from 'react-router-dom';
import Button from './ui/Button';

export default function Footer() {
  return (
    <footer>
      {/* CTA Banner */}
      <div className="bg-blush py-20 text-center px-6">
        <h2 className="font-heading text-4xl text-white font-bold mb-8 italic">Ready to stock your shelves?</h2>
        <Button href="https://florist.smilevase.com" className="bg-white !text-blush hover:bg-gray-50">
          Place a Wholesale Order
        </Button>
      </div>

      {/* Main Footer */}
      <div className="bg-charcoal text-white py-16 px-6 md:px-12">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-12">
          <div className="text-center md:text-left">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/2ba49265b1864ee4c7db35ffc36715be.png" 
              alt="SmileVase Logo" 
              className="h-10 md:h-12 w-auto object-contain mb-6 mx-auto md:mx-0 brightness-0 invert"
            />
            <p className="text-gray-400 font-light max-w-xs mb-4">Custom wrapped vases for florists who care about the details.</p>
            <a href="tel:602-805-5051" className="text-blush font-medium text-lg block hover:underline">602-805-5051</a>
          </div>

          <div className="grid grid-cols-2 gap-12 text-center md:text-left font-light text-sm text-gray-300">
            <div className="flex flex-col gap-4">
              <h4 className="text-white font-semibold uppercase tracking-widest text-xs">Resources</h4>
              <a href="https://florist.smilevase.com" className="hover:text-blush transition-colors">Order Portal</a>
              <a href="mailto:hi@smilevase.com" className="hover:text-blush transition-colors">hi@smilevase.com</a>
              <span className="text-gray-500">Based in Surprise, AZ</span>
            </div>
            <div className="flex flex-col gap-4">
              <h4 className="text-white font-semibold uppercase tracking-widest text-xs">Legal</h4>
              <Link to="/terms" className="hover:text-blush transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="hover:text-blush transition-colors">Privacy Policy</Link>
            </div>
          </div>
        </div>
        
        <div className="container mx-auto mt-16 pt-8 border-t border-white/10 text-center text-xs text-gray-500 font-light">
          © {new Date().getFullYear()} SmileVase. All rights reserved.
        </div>
      </div>
    </footer>
  );
}